module.exports = __webpack_public_path__ + "media/images/icons-1x-7b4fc23cd23f9426cebbd1c721d93f7f.png";